export class NotaryModel {
    notaryId = 0;
    name = "";
    number = "";
    address = "";
    id = "";
}
